import { gql } from "@apollo/client";

export const GET_PAGE = gql`
query Page($culture: String!, $code: String!) {
  page(where: {localization: {culture: $culture}, code: {code: $code}}) {
    __typename
    title
    contentItemId
    description
    code {
      code
    }
    settings {
      contentItems {
        __typename
        ... on PageSettings {
          menuStyle
          menuColor
          coverMode
          footerMode
        }
      }
    }
    content {
      contentItems {
        contentItemId
        contentType
      }
    }
    covers {
      contentItems {
        __typename
        ... on SlideshowItem {
          contentType
          flip
          positionX
          media {
            paths
            texts
          }
          textOverly {
            html
          }
          navigation {
            text
            url
          }
          navigateMode
        }
      }
    }
    cover {
      paths
      texts
    }
    relatedPages {
      contentItems {
        __typename
        ... on Page {
          title
          code {
            code
          }
          description
          cover {
            paths
          }
        }
      }
    }
    fAQs {
      contentItems {
        __typename
        ... on FaqTopic {
          displayText
          items {
            contentItems {
              __typename
              ... on FaqItem {
                displayText
                answer {
                  html
                }
              }
            }
          }
        }
      }
    }
    termsConditions {
      contentItems {
        __typename
        ... on TermsConditions {
          htmlBody {
            html
          }
          name
        }
      }
    }
  }
}
`
